import { render, staticRenderFns } from "./ModalFormPresupuesto.vue?vue&type=template&id=b9465926"
import script from "./ModalFormPresupuesto.vue?vue&type=script&lang=js"
export * from "./ModalFormPresupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports